import { render } from "./Semen.vue?vue&type=template&id=0afaca8b"
import script from "./Semen.vue?vue&type=script&lang=js"
export * from "./Semen.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__